'use strict';
var arrayInputsName = ['address', 'city', 'custom', 'custom2', 'custom3'];
var inputTelValidation;
var inputTextValidation;
function createErrorNotification(message) {
    message = message || 'El formulario contiene errores en los campos, por favor verifique';
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.error-messaging').append(errorHtml);
    $('.error-messaging').removeClass('d-none');
}

function createSuccessNotification(message) {
    var successsHtml = '<div class="alert alert-success alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';
    $('.success-messaging').append(successsHtml);
    $('.success-messaging').removeClass('d-none');
}

function validateFormRequired() {
    $('#lotteryForm input.required').change(function () {
        var valid = true;
        let count = 0;

        $.each($('#lotteryForm input.required'), function (index, inputsForm) {
            count = count++;
            let inputForms = $(inputsForm)[count];
            if (inputForms.type !== 'checkbox') {
                if (!inputForms.value) {
                    valid = false;
                }
            } else {
                valid = $('input[name=' + inputForms.name + ']:checked').length > 0 && valid || false;
            }
        });

        return valid;
    });
}

function removeEmoji(inputTarget) {
    var regex = new RegExp(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g);
    inputTarget.value = inputTarget.value.replace(regex, '');
}

function maxDateAdmited() {
    var input = $('input[type=date]');
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    today = yyyy + '-' + mm + '-' + dd;
    input.attr('min', '1899-01-01');
    input.attr('max', today);
}

function checkAvailability(arr, val) {
    return arr.some(function (arrVal) {
        return val === arrVal;
    });
}

function litsenerValidateInputForm(input) {
    var regex;
    var valueInputChanged = $('#' + input.id).val();
    var errorInputID = 'form-' + input.name + '-error';
    var nameInput = input.name;
    var isRquired = $('#' + input.id).attr('required') === 'required' || false;
    $('#' + errorInputID).hide();
    switch (input.type) {
        case 'text':
            var validateInputCustom = checkAvailability(arrayInputsName, nameInput);
            if (isRquired) {
                if (!validateInputCustom) {
                    regex = new RegExp(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]$/g);
                    inputTextValidation = regex.test(valueInputChanged);
                    if (!inputTextValidation) {
                        $('#' + errorInputID).text('Ingresá solo caracteres de tipo texto').show();
                    }
                } else if (!valueInputChanged) {
                    if (input.name === 'address') {
                        $('.lottery__btn').prop('disabled', true);
                        $('#' + errorInputID).text('Por favor ingresá tu dirección').show();
                    } else if (input.name === 'city') {
                        regex = new RegExp(/[$%&|<>#]/g);
                        inputTextValidation = regex.test(valueInputChanged);
                        if (!inputTextValidation) {
                            $('.lottery__btn').prop('disabled', true);
                            $('#' + errorInputID).text('Por favor ingresá ciudad valida').show();
                        }
                    } else {
                        $('.lottery__btn').prop('disabled', true);
                        $('#' + errorInputID).text('Por favor ingresá información en el campo').show();
                    }
                }
            }
            break;
        case 'tel':
            regex = new RegExp(/^(?:(?:00)?5490?)?0?(?:11|[23068]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/g);
            inputTelValidation = regex.test(valueInputChanged);
            if (!inputTelValidation) {
                $('.lottery__btn').prop('disabled', true);
                $('#' + errorInputID).text('Ingresá un número válido, sin guiones.').show();
            }
            break;
        case 'email':
            regex = new RegExp(/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/g);
            var inputEmailValidation = regex.test(valueInputChanged);
            if (!inputEmailValidation) {
                $('.lottery__btn').prop('disabled', true);
                $('#' + errorInputID).text('Ingresá un email válido nameemail@ejemplo.com').show();
            }
            break;
        case 'number':
            regex = new RegExp(/^[0-9]*$/g);
            var inputNumberValidation = regex.test(valueInputChanged);
            if (inputNumberValidation) {
                if (input.name === 'dni') {
                    if (!valueInputChanged) {
                        $('#' + errorInputID).text('Por favor ingresá un DNI').show();
                        $('.lottery__btn').prop('disabled', true);
                    }
                    regex = new RegExp(/^[\d]{1,3}\.?[\d]{3,3}\.?[\d]{3,3}$/g);
                    inputNumberValidation = regex.test(valueInputChanged);
                    if (!inputNumberValidation) {
                        $('.lottery__btn').prop('disabled', true);
                        $('#' + errorInputID).text('Por favor ingresá un DNI válido').show();
                    }
                } else if (input.name === 'newPhone') {
                    regex = new RegExp(/^(?:(?:00)?5490?)?0?(?:11|[23068]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/g);
                    inputTelValidation = regex.test(valueInputChanged);
                    if (!inputTelValidation) {
                        $('#' + errorInputID).text('Ingresá un número válido, sin guiones.').show();
                        $('.lottery__btn').prop('disabled', true);
                    }
                }
            } else {
                $('#' + errorInputID).text('Por favor ingresá un número').show();
                $('.lottery__btn').prop('disabled', true);
            }
            break;
        case 'checkbox':
            var inputCheckboxValidation = $('input[name=' + input.name + ']:checked').length > 0;
            if (isRquired) {
                if (input.id !== 'lottery-form-tac') {
                    if (inputCheckboxValidation) {
                        $('#' + input.id).val(true);
                    } else {
                        $('#' + input.id).val(null);
                        $('#' + errorInputID).text('Para continuar, deberás aceptar.').show();
                    }
                } else if (inputCheckboxValidation) {
                    $('#lottery-form-tac').val(true);
                } else {
                    $('#lottery-form-tac').val(null);
                    $('#' + errorInputID).text('Para continuar deberás aceptar las Políticas de Privacidad y los Términos y Condiciones.').show();
                }
            } else if (inputCheckboxValidation) {
                $('#' + input.id).val(true);
            } else {
                $('#' + input.id).val(false);
                $('#' + errorInputID).text('Para continuar deberás aceptar las Políticas de Privacidad y los Términos y Condiciones.').show();
            }
            break;
        case 'date':
            if (!valueInputChanged) {
                $('#' + errorInputID).text('Ingresá una fecha de cumpleaños').show();
                $('.lottery__btn').prop('disabled', true);
            } else {
                var toDayDate = new Date();
                var dateForm = new Date(valueInputChanged);
                if (dateForm >= toDayDate) {
                    $('#' + errorInputID).text('Ingresá una fecha valida de cumpleaños').show();
                    $('#' + input.id).val('');
                }
            }
            break;
        default:
    }
}
function buttonValidate(input) {
    var arrayValueInputs = $('#lotteryForm input.required').map(function () {
        return $(this).val();
    }).get();
    if (arrayValueInputs.includes('')) {
        $('.lottery__btn').prop('disabled', true);
    } else {
        $('.lottery__btn').prop('disabled', false);
    }
}

function initialzeForm() {
    $('form :input').change(function (e) {
        removeEmoji(e.target);
        litsenerValidateInputForm(e.currentTarget);
        buttonValidate(e.currentTarget);
    });
}

function addRegistrerForm() {
    let lotteryBtn = document.querySelector(
        '#lotteryBtn'
    );
    lotteryBtn.addEventListener('click', function () {
        var url = $('.lottery__btn').attr('data-action-url');
        $.spinner().start();
        var form = $('.lottery__form');

        var shippingFormData = form.serialize();
        $.ajax({
            url: url,
            method: 'POST',
            data: shippingFormData,
            success: function (data) {
                if (data.success === true) {
                    createSuccessNotification(data.msg);
                    location.href = data.redirectUrl;
                } else {
                    createErrorNotification(data.msg);
                }
                $.spinner().stop();
            },
            error: function (err) {
                $.spinner().stop();
            }
        });
    });
}

function createdDateNow() {
    let currentDate = new Date();
    let localTimestamp = currentDate.toLocaleString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires', hour12: false });
    $('#RegistrationDate').val(localTimestamp);
}

function OnInitComponent() {
    $('.lottery__btn').prop('disabled', true);
    initialzeForm();
    addRegistrerForm();
    $('.lottery__btn').prop('disabled', validateFormRequired());
    createdDateNow();
    maxDateAdmited();
}

module.exports = {
    OnInitComponent: OnInitComponent
};
